export const getDigitsOnly = (value: string | undefined | null): string => {
    return value?.replace(/\D/g, '') || '';
}; 